module.exports = __webpack_public_path__ + "static/media/tt.333675d6.svg";